import React, { Fragment } from "react";
import TeamSlider from "./teamSlider";
import TeamMiddleSlider from "./teamMiddleSlider";
import Momios from "./momios";
import "./bodyCardEventSlider.sass";
import SectionF1 from "./formula1/seccionF1.js/sectionf1";
import PistaF1 from "./formula1/pistaf1";

export default function BodyCardEventSlider({
    imgL, momioL, nameL, scoreL, urlMomioL, classTeamL,
    imgR, momioR, nameR, scoreR, urlMomioR, classTeamR,
    momioM, urlMomioM, urlEvento, flagMomios, classGame, sport, podium,
    venue_name, venue_state, venue_country, circuit_image, opta_event_url

}) {

    return (
        <>
            {String(sport).toUpperCase() === "MTR"
                ?
                <div className="container-body-formula1">
                    {podium && podium.length > 0
                        ? podium.map((item, i) =>
                            <Fragment key={i}>
                                <SectionF1 order={i + 1} opta_event_url={opta_event_url} left_score={item.left_score} left_short_name={item.left_short_name} firstName={item.firstName} lastName={item.lastName} team={item.team} driverNumber={item.driverNumber} timeString={item.timeString} nationalityCode={item.nationalityCode} />
                            </Fragment>
                        )
                        : <PistaF1 opta_event_url={opta_event_url} venue_name={venue_name} venue_state={venue_state} venue_country={venue_country} circuit_image={circuit_image} />
                    }
                </div>
                :
                <div className={flagMomios === 'true' ? 'container-body-card heightM' : "container-body-card heightSM"}>

                    <div className="body-card-evento-slider">
                        <TeamSlider nameTeam={nameL} imgTeam={imgL} altTeam={nameL} momioTeam={momioL} pointsTeam={scoreL} urlEvento={urlEvento} classTeam={classTeamL} flagMomios={flagMomios} isLeft={true} classGame={classGame} />
                        <TeamMiddleSlider urlEvento={urlEvento} />
                        <TeamSlider nameTeam={nameR} imgTeam={imgR} altTeam={nameR} momioTeam={momioR} pointsTeam={scoreR} urlEvento={urlEvento} classTeam={classTeamR} flagMomios={flagMomios} isLeft={false} classGame={classGame} />
                    </div>

                    {flagMomios === 'true' && classGame !== "clarosports-finished-game" && classGame !== "clarosports-error-game" &&
                        <Momios urlMomioL={urlMomioL} urlMomioR={urlMomioR} urlMomioM={urlMomioM} momioL={momioL} momioR={momioR} momioM={momioM} urlEvento={urlEvento} />
                    }
                </div>
            }
        </>
    );
}
